export function registerReveal(): void {
    let observer: IntersectionObserver;

    function createObserver(threshold: number): void {
        if (observer) {
            observer.disconnect();
        }

        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const { target, isIntersecting } = entry;

                if (!isIntersecting)
                    return;

                // Apply transition and stop observing
                target.removeAttribute('aria-hidden');
                observer.unobserve(target);
            });
        }, { threshold });

        // Get all elements that have a data-reveal attribute set
        const $elements = document.querySelectorAll('[data-reveal]');

        $elements.forEach($el => {
            // Only observe elements which have a valid reveal transition registered
            const reveal = $el.getAttribute('data-reveal');

            if (reveal == null) {
                return void console.error(`Missing reveal id for element!`, $el);
            }

            $el.setAttribute('aria-hidden', 'true');
            observer.observe($el);
        });
    }

    function updateThreshold(): void {
        // Check if current view is a mobile view based on the viewport width
        const isMobileView = window.matchMedia('(max-width: 768px)').matches;

        // Set the threshold value based on the viewport
        const threshold = isMobileView ? 0.2 : 0.5;

        createObserver(threshold);
    }

    // Initial setup
    updateThreshold();

    // Update threshold value when viewport changes
    window.addEventListener('resize', updateThreshold);
}